import makeStyles from '@mui/styles/makeStyles';

export const useStyles = makeStyles((theme) => ({
  inputs: {
    display: 'flex',
    marginTop: theme.spacing(1),
  },
}));
